<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
        </div>
        <div class="d-flex align-items-center">
          <form class="search-box position-relative me-15" @submit.prevent="rechercher">
            <input type="text" v-model="searchTerm" @keyup="rechercher"
              class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un marché" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
  
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
  
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                    Code
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                    Libelle
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                    Taux (%)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                    {{ el.code }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black">
                  {{ el.libelle }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black">
                  {{ el.taux }}
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
   
  </template>
  <script lang="ts">
  import { defineComponent, onMounted, ref  } from "vue";
  import ApiService from "@/services/ApiService";
  import { format_date, showModal, suppression, error, } from "@/utils/utils";
  import { useRouter } from "vue-router";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
import { GroupeDeTaxe } from "@/models/GroupeDeTaxe";
  
  export default defineComponent({
    name: "ListeGroupeDeTaxe",
    components: {
      PaginationComponent
    },
    setup: () => {
  
      onMounted(() => {
        getAll();
      });
  
      const elements = ref<Array<GroupeDeTaxe>>([]);
      const loading = ref<boolean>(false);
      const router = useRouter();
  
      // BEGIN PAGINATE
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
  
      const handlePaginate = ({ page_, limit_ }: { page_: number, limit_: number }) => {
        try {
          page.value = page_;
          getAll(page_, limit_);
        } catch (error) {
          //
        }
      };
  
       function rechercher(){
        getAll(page.value, limit.value, searchTerm.value );
      }
  
      const recharger = () => {
        getAll();
      };
      // END PAGINATE
  
      onMounted(() => {
        loading.value=false;
        getAll()
      });
  
      const refreshMarches = () => {
        getAll();
      };
  
      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`/all/groupeDeTaxe?page=${page}&limit=${limi}&mot=${searchTerm}&`)
          .then(({ data }) => {
            elements.value = data.data.data;
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            return data.data;
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
      }
      
      
  
      const privileges = ref<Array<string>>(JwtService.getPrivilege());
  
      const checkMarche = (name:string) => {
        return privileges.value.includes(name);
      }
  
      return {suppression,
        checkMarche,
        elements,
        getAll,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        searchTerm,
        rechercher,
        recharger,
        refreshMarches,
       };
    },
  
   
  });
  </script>